import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {PromotionMessageWizardModel} from '../../../../models/promotion-message.model';
import {PromotionWizardService} from '../../../../services/promotion/promotion-wizard.service';
import {PromotionCampaignModel} from '../../../../models/promotion-campaign.model';
import {PromotionCampaignService} from '../../../../services/promotion/promotion-campaign.service';

@Component({
  selector: 'kv-promo-campaign-detail',
  template: `
    <div class="Customers customer-company ui-g">
      <div class="ui-g ui-fluid" style="width: 100%">
        <div class="ui-g-12">
          <div>
            <div class="ui-g ui-g-nopad form-group master-data">
              <div class="ui-g-12 ui-lg-8 ui-g-nopad">
                <h1 class="step-title">{{ titlePage | translate}}</h1>
              </div>
              <div class="ui-g-12 ui-lg-4 text-right">
                <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" label="{{ 'promotion.backToCampaigns' | translate }}"
                        (click)="locationBack()"></button>
              </div>
              <div class="ui-g-12 ui-lg-12 ui-g-nopad customers-steps">
                <p-steps [style]="{'width': '100%'}" [model]="items" [(activeIndex)]="activeTabIndex"
                         [readonly]="false"></p-steps>
              </div>
            </div>
          </div>
          <div class="ui-g-12">
            <div class="card" [hidden]="this.activeTabIndex !== activeTab.chooseCampaign">
              <kv-promo-tab-choose-campaign
                [wizardCampaigns]="wizardCampaigns"
                (nextStep)="downloadConfigAndGoToHeadTab($event)"
                [disableChooseCampaign]="disableChooseCampaign"
                [selectedWizard]="selectedWizard">
              </kv-promo-tab-choose-campaign>
            </div>
            <div class="card" [hidden]="this.activeTabIndex !== activeTab.head">
              <kv-promo-tab-head
                *ngIf="selectedWizard"
                [configs]="headConfigs"
                [addEditCampaign]="addEditCampaign"
                [selectedWizard]="selectedWizard"
                [campaignTypes]="campaignTypes"
                (saveHead)="saveHeadTab($event)">
              </kv-promo-tab-head>
            </div>
            <div class="card" [hidden]="this.activeTabIndex !== activeTab.touchPoint">
              <kv-promo-tab-touch-point
                [touchPoints]="touchPoints"
                [addEditCampaign]="addEditCampaign">
              </kv-promo-tab-touch-point>
            </div>
            <div class="card" [hidden]="this.activeTabIndex !== activeTab.detail">
              <kv-promo-tab-detail
                [addEditCampaign]="addEditCampaign"
                [configs]="detailsConfigs">
              </kv-promo-tab-detail>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
})
export class CampaignDetailComponent implements OnInit {

  @Input() titlePage;
  @Input() wizardCampaigns;
  @Input() addEditCampaign;
  @Input() campaignTypes;
  @Input() touchPoints;

  @Output() hide = new EventEmitter();

  tab = false;
  items: MenuItem[] = [];
  activeTabIndex = 0;
  disableChooseCampaign = false;

  headConfigs: PromotionMessageWizardModel[];
  touchpointsConfigs: PromotionMessageWizardModel[];
  detailsConfigs: PromotionMessageWizardModel[];

  activeTab = {
    chooseCampaign: 0,
    head: 1,
    touchPoint: 2,
    detail: 3
  };
  selectedWizard = null;

  static fillConfigArray(array: PromotionMessageWizardModel[], configs: PromotionMessageWizardModel[]) {
    for (let elem of configs) {
      array.push(elem);
    }
  }

  constructor(private srvTranslate: TranslateService,
              private svcWizard: PromotionWizardService,
              private svcCampaign: PromotionCampaignService) {
    this.srvTranslate.get(['promotion.chooseCampaign']).subscribe((res1) => {
      this.items.push(
        {label: res1['promotion.chooseCampaign'], disabled: false}
      );
      this.srvTranslate.get(['promotion.head']).subscribe((res2) => {
        this.items.push(
          {label: res2['promotion.head'], disabled: true}
        );
        this.srvTranslate.get(['promotion.touchPoint']).subscribe((res3) => {
          this.items.push(
            {label: res3['promotion.touchPoint'], disabled: true}
          );
          this.srvTranslate.get(['promotion.detail']).subscribe((res4) => {
            this.items.push(
              {label: res4['promotion.detail'], disabled: true}
            );
          });
        });
      });
    });
  }

  ngOnInit(): void {
    if (this.addEditCampaign) {
      this.downloadConfigAndGoToHeadTab(this.addEditCampaign.wizard_id, true)
    }
  }

  locationBack() {
    this.hide.emit();
  }

  downloadConfigAndGoToHeadTab(wizId, edit = false) {
    this.svcWizard.getConfig(wizId).subscribe(res => {
      this.clearConfigs();
      let configs = JSON.parse(res);
      for (let elem of configs) {
        switch (elem['step']) {
          case 'main': {
            CampaignDetailComponent.fillConfigArray(this.headConfigs, elem['fields']);
            break;
          }
          case 'details': {
            CampaignDetailComponent.fillConfigArray(this.detailsConfigs, elem['fields']);
            break;
          }
          case 'touchPoint': {
            CampaignDetailComponent.fillConfigArray(this.touchpointsConfigs, elem['fields']);
            break;
          }
          default: {
            break;
          }
        }
      }

      // mi prendo l'id del wizard
      this.selectedWizard = wizId;

      // disabilito la scelta wizard
      this.disableChooseCampaign = true;

      // se sono in modifica tutto sbloccato
      if (edit) {
        // sblocco tutto
        this.items[0].disabled = false;
        this.items[1].disabled = false;
        this.items[2].disabled = false;
        this.items[3].disabled = false;
      } else {
        // sblocco solo la tab testata e wiz
        this.items[0].disabled = false;
        this.items[1].disabled = false;
      }

      this.activeTabIndex = 1;
    });
  }

  private clearConfigs() {
    this.headConfigs = [];
    this.detailsConfigs = [];
    this.touchpointsConfigs = [];
  }


  saveHeadTab(item: PromotionCampaignModel) {
    if (!item.id) {
      this.svcCampaign.create(item).subscribe( (res) => {
        /*
        * se la create va a buon fine mi preparo l'oggetto in edit
        * e sblocco le tab touch point e detail*/
        PromotionCampaignService.parseFromCharToBoolean(res);
        this.addEditCampaign = res;
        this.items[0].disabled = false;
        this.items[1].disabled = false;
        this.items[2].disabled = false;
        this.items[3].disabled = false;
      }, () => {
        this.items[0].disabled = false;
        this.items[1].disabled = false;
        this.items[2].disabled = true;
        this.items[3].disabled = true;
      });
    } else {
      this.svcCampaign.update(item).subscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/components/campaignDetail.component.ts